import { EnvironmentModel, ProjectName } from "./environment-model.interface";

export const environment: EnvironmentModel = {
  production: false,
  apiUrl: 'https://testapi.exposer.app',
  url: 'https://testadmin.exposer.app',
  crossTestProdSiblingUrl: 'https://admin.exposer.app',
  name: ProjectName.exposer,
  heliosUrl: 'https://heliostest.exposer.app/'
};